<div class="mct-flex mct-col mct-grid mct-cols-1 mct-grid-gt-md profile-listing-grid mct-gap-10">
  <div class="mct-flex mct-col mct-gap-10">
    <div>
      <div>{{ 'listing.listing-category' | translate | titlecase }}</div>
      <div>
        <select class="form-control" [(ngModel)]="value.CategoryID" (change)="onCategoryChange($event.target.value)">
          <option *ngFor="let category of categories" [value]="category.CategoryID">{{ category.Category }}</option>
        </select>
      </div>
    </div>

    <div *ngIf="mySubCategories?.length">
      <div>{{ 'listing.listing-subcategory' | translate | titlecase }}</div>
      <div>
        <select class="form-control" [(ngModel)]="value.SubCategoryID" (change)="onSubCategoryChange()">
          <option *ngFor="let subCategory of mySubCategories" [value]="subCategory.SubCategoryID">{{
            subCategory.SubCategory }}</option>
        </select>
      </div>
    </div>

    <div>
      <div>{{ 'listing.listing-level' | translate | titlecase }}</div>
      <select class="form-control" [(ngModel)]="value.ListingTypeID">
        <option [ngValue]="undefined">{{ 'common.none' | translate | titlecase }}</option>
        <option *ngFor="let listingType of listingTypes" [value]="listingType.ListingTypeID">{{ listingType.ListingType
          }}</option>
      </select>
    </div>

    <div>
      <div>
        {{ 'listing.details-listing-level' | translate | titlecase }}
      </div>
      <div>
        <select class="form-control" [(ngModel)]="value.DetailsListingTypeID">
          <option [ngValue]="0">{{ 'common.none' | translate | titlecase }}</option>
          <option *ngFor="let listingType of listingTypes" [value]="listingType.ListingTypeID">{{
            listingType.ListingType }}
          </option>
        </select>
      </div>
    </div>

    <div>
      <div>
        {{ 'listing.listing-position' | translate | titlecase }}
      </div>
      <div>
        <select class="form-control" [(ngModel)]="value.ListingPrefix">
          <option [ngValue]="0">{{ 'common.none' | translate | titlecase }}</option>
          <option *ngFor="let listingPosition of listingPositions" [value]="listingPosition.ListingPrefix">
            {{ listingPosition.Name }}
          </option>
        </select>
      </div>
    </div>

    <div class="flex row gap-10px">
      <label class="mct-flex mct-row">
        <input type="checkbox" [(ngModel)]="value.PrimaryListing" (change)="primaryListingChanged(value)" />
        <span class="ml-1">{{ 'listing.primary-listing' | translate | titlecase }}</span>
      </label>
      <label class="mct-flex mct-row">
        <input type="checkbox" [(ngModel)]="value.WebListing" />
        <span class="ml-1">{{ 'listing.web-listing' | translate | titlecase }}</span>
      </label>
      <label class="mct-flex mct-row">
        <input type="checkbox" [(ngModel)]="value.PrintListing" />
        <span class="ml-1">{{ 'listing.print-listing' | translate | titlecase }}</span>
      </label>
      <label class="mct-flex mct-row">
        <input type="checkbox" [(ngModel)]="value.Active" />
        <span class="ml-1">{{ 'common.active' | translate | titlecase }}</span>
      </label>
    </div>

    <div>
      <div>{{ 'listing.auto-fill-coords' | translate | titlecase }}</div>
      <p-checkbox [(ngModel)]="value.ShowMap" [binary]="true"></p-checkbox>
    </div>

    <div class="mct-flex mct-row mct-wrap mct-gap-27">
      <div>
        <div>{{ 'listing.latitude' | translate | titlecase }}</div>
        <input type="text" class="form-control" [(ngModel)]="value.Latitude" />
      </div>
      <div>
        <div>{{ 'listing.longitude' | translate | titlecase }}</div>
        <input type="text" class="form-control" [(ngModel)]="value.Longitude" />
      </div>
    </div>
    <div>
      <div>{{ 'listing.entity' | translate | titlecase }}</div>
      <div>
        <select class="form-control" [(ngModel)]="value.EntityID" (change)="onEntityChange()">
          <option selected [ngValue]="undefined">{{ 'listing.entity-none' | translate }}</option>
          <option *ngFor="let entity of entities" [ngValue]="entity.EntityID">{{ entity.AffCode }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="mct-flex mct-col mct-gap-10">
    <div>
      <div>{{ 'listing.long-description' | translate | titlecase }}</div>
      <div *ngIf="showEditor && value.Descr != null">
        <wl-wysiwyg-editor [showHtmlTemplates]="false" [disableImageSelector]="true"
          [(ngModel)]="value.Descr"></wl-wysiwyg-editor>
      </div>
    </div>
    <div>
      <div>{{ 'listing.short-description' | translate | titlecase }}</div>
      <textarea [(ngModel)]="value.ShortDescr" class="form-control"></textarea>
    </div>
    <div>
      <div>
        {{ 'listing.products-and-services' | translate | titlecase }}
      </div>
      <div>
        <textarea [(ngModel)]="value.ProductsAndServices" class="form-control"></textarea>
      </div>
    </div>
    <div>
      <div>
        {{ 'listing.keywords' | translate | titlecase }}
      </div>
      <div>
        <textarea [(ngModel)]="value.Keywords" class="form-control"></textarea>
      </div>
    </div>
    <div class="mct-flex mct-justify-end mct-items-center mct-gap-5">
      <a (click)="copyClicked()" style="cursor:pointer">{{ 'listing.copy-descriptive' | translate | titlecase }}</a>
      <img src="/assets/img/help.png" class="wc-help-icon" />
    </div>
  </div>
</div>

<hr />

<p-accordion>
  <p-accordion-panel value="0">
    <p-accordion-header>
      {{ 'listing.expand-listing-overrides' | translate | titlecase }}
    </p-accordion-header>
    <p-accordion-content>
      <div class="mct-flex mct-col mct-gap-20">

        <div class="mct-flex mct-row">
          <p-checkbox binary="true" [(ngModel)]="value.OverrideSystemPreferences" inputId="osp"></p-checkbox>
          <label for="osp" class="ml-2 mb-0">{{ 'listing.hide-listing-fields' | translate | titlecase }}</label>
        </div>

        <ul class="list-unstyled ml-4 mct-flex mct-col mct-gap-10">
          <li class="mct-flex mct-row">
            <p-checkbox binary="true" [(ngModel)]="value.ShowAddress" [trueValue]="false" [falseValue]="true"
              inputId="s1"></p-checkbox>
            <label for="s1" class="ml-2 mb-0">{{ 'listing.hide-address' | translate | titlecase }}</label>
          </li>
          <li class="mct-flex mct-row">
            <p-checkbox binary="true" [(ngModel)]="value.ShowPhone" [trueValue]="false" [falseValue]="true"
              inputId="s2"></p-checkbox>
            <label for="s2" class="ml-2 mb-0">{{ 'listing.hide-phone-number' | translate | titlecase }}</label>
          </li>
          <li>
            <p-checkbox binary="true" [(ngModel)]="value.ShowWebsite" [trueValue]="false" [falseValue]="true"
              inputId="s3"></p-checkbox>
            <label for="s3" class="ml-2 mb-0">{{ 'listing.hide-website' | translate | titlecase }}</label>
          </li>
          <li>
            <p-checkbox binary="true" [(ngModel)]="value.ShowEmail" [trueValue]="false" [falseValue]="true"
              inputId="s4"></p-checkbox>
            <label for="s4" class="ml-2 mb-0">{{ 'listing.hide-contact-form' | translate | titlecase }}</label>
          </li>
          <li>
            <p-checkbox binary="true" [(ngModel)]="value.ShowBusDescr" [trueValue]="false" [falseValue]="true"
              inputId="s5"></p-checkbox>
            <label for="s5" class="ml-2 mb-0">{{ 'listing.hide-descr' | translate | titlecase }}</label>
          </li>
        </ul>

        <div class="flex column gap-27px w-100">
          <div class="flex column">
            <div>
              <p-checkbox binary="true" [(ngModel)]="value.OverrideProfileSettings" inputId="ops"></p-checkbox>
              <label for="ops" class="ml-2 mb-0">{{ 'listing.override-profile-information' | translate | titlecase
                }}</label>
            </div>
            <div>{{ 'listing.override-tooltip' | translate }}</div>
          </div>

          <div>
            <label>{{ 'listing.display-name' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.DisplayName" />
          </div>

          <div class="w-100">
            <div>{{ 'listing.display-related-profile' | translate | titlecase }}</div>
            <p-select [options]="relatedProfileSelectItems" [(ngModel)]="value.RelatedProfileIdOverride"
              placeholder="{{ 'listing.no-profile' | translate }}" styleClass="w-100">
            </p-select>
          </div>

          <div>
            <label>{{ 'listing.street-address' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.Address1" />
          </div>

          <div>
            <label>{{ 'common.personal-information.address2' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.Address2" />
          </div>

          <div>
            <label>{{ 'common.personal-information.city' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.City" />
          </div>

          <div class="grid columns-1fr-1fr-2fr">
            <div class="flex column mr-27">
              <label>{{ 'common.personal-information.state' | translate | titlecase }}</label>
              <wl-state-selector-modern [(selectedState)]="addressState"></wl-state-selector-modern>
            </div>
            <div>
              <label>{{ 'common.personal-information.zip' | translate | titlecase }}</label>
              <input type="text" class="form-control" [(ngModel)]="value.Zip" />
            </div>
          </div>

          <div>
            <label>{{ 'common.personal-information.phone-number' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.Phone" />
          </div>
          <div>
            <label>{{ 'common.personal-information.website' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.Website" />
          </div>
          <div>
            <label>{{ 'common.personal-information.email-address' | translate | titlecase }}</label>
            <input type="text" class="form-control" [(ngModel)]="value.Email" />
          </div>
        </div>

      </div>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
